import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import classNames from "classnames";

import { history } from "src/App";

export const CNavItem = ({ data }) => {
  //#region Data
  const location = useLocation();

  const isSelected = useMemo(
    () => location?.pathname?.startsWith(data?.to),
    [location, data?.to]
  );
  //#endregion

  //#region Render
  return (
    <div
      onClick={() => history.push(data?.to)}
      className={classNames(
        "!px-4 !pl-[3.3rem] !py-2 whitespace-nowrap text-[#053C7F] text-base cursor-pointer hover:bg-[#d2dff5]",
        isSelected && "nav-selected bg-blue-200 hover:bg-blue-200"
      )}
    >
      {data?.name}
    </div>
  );
  //#endregion
};
